import presentationModules from './presentation/index'
import pricingModules from './pricing/index'
import configurationModules from './configuration/index'
import zoomAppModule from './zoomApp.module'
import homePage from './homePage.module'
import notificationModule from './notification.module'
import slidesGeneratorFeedbackModule from './openAI/slidesGeneratorFeedback.module'
import onboardingModule from './onBoarding.module'
import openAIModules from './openAI/index'
import userAdsCampaignModule from './userAdsCampaign.module'
import trialPlanModule from './trialPlan.module'
import rightColumnModules from './right-column/index'
import wordCloudModule from './wordcloud.module.js'
import hotkeyModules from './hotkey'
import slideModules from './slide/index'
import uploaderModules from './uploader/index'
import featureTogglesModule from './featureToggles.module'
import categorise from './slides/categorise.module'
import liveStatsModule from './liveStats.module'
import liveStatsV2Module from './live-stats-v2/live-stats.module'
import progressBarModule from './progressBar.module'
import slideOptionModule from './slide-options'
import userSettingsModule from './user-settings/index'
import trash from './trash.module'
import keyword from './keyword.module'
import systemConnection from '@/vuex/modules/system/system-connection.module'
import questionRecommendations from './question-recommendations.module'
import presetModule from './preset.module'
import imageKeywordSuggestions from './image-keyword-suggestion.module'
import kvSyncModule from './kvSync.module'
import resourceManagement from './resource-management.module'
import leaderboardModule from './leaderboard.module'
import redirectModule from './redirect.module'
import history from './history/history.module'
import wheelEvent from './wheelEvent.module'
import inlineCSAT from './inlineCSAT.module'
import templatesModule from '@/vuex/modules/templates/templates.module'
import preventLockScreenModule from '@/vuex/modules/prevent-lock-screen/prevent-lock-screen.module'
import ahaAIModules from './aha-ai/index'
import hackathong2025Module from '@/vuex/modules/hackathon-2025/hackathon-2025.module'
import embedSlide from './embed-slide.module'
import slideAnnotationsModule from './slide-annotations/slide-annotations.module'
import multipleSessionsModule from '@/vuex/modules/multiple-session/multiple-session.module'

export default {
  ...presentationModules,
  ...pricingModules,
  ...configurationModules,
  zoomApp: zoomAppModule,
  trialPlan: trialPlanModule,
  homePage,
  categorise,
  notificationModule,
  wordCloud: wordCloudModule,
  liveStats: liveStatsModule,
  liveStatsV2: liveStatsV2Module,
  kvSync: kvSyncModule,
  resource: resourceManagement,
  onBoarding: onboardingModule,
  slideOptionModule,
  ...slidesGeneratorFeedbackModule,
  ...openAIModules,
  userAdsCampaign: userAdsCampaignModule,
  userSettings: userSettingsModule,
  ...rightColumnModules,
  ...hotkeyModules,
  ...slideModules,
  ...uploaderModules,
  featureToggles: featureTogglesModule,
  progressBar: progressBarModule,
  trash,
  keyword,
  imageKeywordSuggestions,
  systemConnection,
  questionRecommendations,
  presetModule,
  leaderboard: leaderboardModule,
  redirectModule,
  history,
  wheelEvent,
  inlineCSAT,
  templates: templatesModule,
  preventLockScreen: preventLockScreenModule,
  ...ahaAIModules,
  hackathong2025: hackathong2025Module,
  embedSlide,
  slideAnnotations: slideAnnotationsModule,
  multipleSessions: multipleSessionsModule,
}
